import posthog from "posthog-js";

import { useIsTabStale } from "@/lib/zustand/useIsTabStale";

export const reportServerActionSkew = (serverActionId: string) => {
  // Tagged so deploy-skew failures can be filtered and alerted on in PostHog error tracking; nothing is thrown anywhere for them, so this is the only record
  posthog.captureException(
    new Error("Server action not found on the current deployment"),
    {
      isServerActionSkew: true,
      serverActionId,
      pathname: window.location.pathname,
    }
  );

  useIsTabStale.getState().markTabStale();
};
